import { render, staticRenderFns } from "./ViewBlackListReadOnly.vue?vue&type=template&id=0bd49044&scoped=true"
import script from "./ViewBlackListReadOnly.vue?vue&type=script&lang=js"
export * from "./ViewBlackListReadOnly.vue?vue&type=script&lang=js"
import style0 from "./ViewBlackListReadOnly.vue?vue&type=style&index=0&id=0bd49044&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bd49044",
  null
  
)

export default component.exports